import { QueryCriteria } from '@records/records-search/shared/search-filters.model';
import { FILTER_HIDDEN_RECORD } from '@shared/utils/helpers/shared.helper';

export function getCompanyFilter(companyId: string): QueryCriteria {
  return {
    type: 'equal',
    field: 'company_contact_role_addresses/company_id',
    key: 11883,
    values: companyId,
    dataType: 'id',
    name: 'Company ID',
  };
}

export function getCompanyAliasFilter(companyId: string): QueryCriteria {
  return {
    type: 'equal',
    field: 'alias_company.id',
    key: 18762,
    values: companyId,
    dataType: 'id',
    name: 'Alias Company ID',
  };
}

export function getAvailabiltiesByIdsFilter(ids: number[]): QueryCriteria {
  return {
    dataType: 'id',
    field: 'entity.id',
    key: 701,
    name: 'Availability ID',
    type: 'multi',
    values: ids,
  };
}

export function getCompanyIdAtRootFilter(companyId: string): QueryCriteria {
  return {
    type: 'equal',
    field: 'company_id',
    key: 11883,
    values: companyId,
    dataType: 'id',
    name: 'Company ID',
  };
}

export function getPropertyFilter(propertyId: string): QueryCriteria {
  return { dataType: 'id', field: 'property.id', type: 'equal', values: propertyId, name: 'Property ID' };
}

export function getCompanyPropertiesFilter(companyId: string): QueryCriteria {
  return {
    type: 'equal',
    field: 'usages/company_contact_role_addresses/company_id',
    key: 11883,
    values: companyId,
    dataType: 'id',
    name: 'Company ID',
  };
}

export function getPropertyTenantsFilter(propertyId: string): QueryCriteria {
  return {
    name: 'Property Id',
    key: 3789,
    type: 'equal',
    field: 'property_id',
    values: propertyId,
    dataType: 'id',
  };
}
export const NOT_DELETED = {
  type: 'multiNotEqual',
  field: 'miq_record_hide_f',
  values: ['true'],
  dataType: 'boolean',
  name: 'Hidden Lease Records',
};

export const mandatoryLeaseFilters = [
  {
    type: 'multiNotEqual',
    field: 'ref_arrangement_status_desc',
    values: ['Inactive'],
    dataType: 'text',
    name: 'Comp Status',
  },
];

export const mandatorySaleFilters = [
  {
    key: 2273,
    type: 'multiNotEqual',
    field: 'ref_arrangement_status_desc',
    values: ['Inactive'],
    dataType: 'text',
    name: 'Comp Status',
  },
];
export const mandatoryPropertiesFilters = [
  FILTER_HIDDEN_RECORD,
  {
    type: 'multiNotEqual',
    field: 'ref_property_status_desc',
    values: ['Deleted', 'Demolished', 'Inactive', 'Converted'],
    dataType: 'text',
  },
];

export const mandatoryAvailabilitiesFilters = [
  FILTER_HIDDEN_RECORD,
  {
    name: 'Availability Status',
    key: 2, // Availability Status Filter key
    type: 'multiNotEqual',
    field: 'ref_space_availability_status_desc',
    values: ['Deleted', 'Off Market', 'Renewed', 'Sold', 'Withdrawn'],
    dataType: 'text',
  },
];

export const mandatoryTenancyFilters = [
  FILTER_HIDDEN_RECORD,
  {
    name: 'Tenancy Status',
    key: 3785, // Tenancy Status Filter key
    type: 'multiNotEqual',
    field: 'property_space/tenancy_status',
    values: ['Expired', 'Gone', 'No Longer Tenant'],
    dataType: 'text',
  },
];

export const mandatoryTimFilters = [
  FILTER_HIDDEN_RECORD,
  {
    name: 'TIM Status',
    key: 16071, // Tim Status Filter key
    field: 'status_type_desc',
    type: 'multiNotEqual',
    values: ['Closed'],
    dataType: 'text',
  },
];

export const hiddenAndMatchVerifiedFilters = [
  FILTER_HIDDEN_RECORD,
  {
    name: 'Availability Status',
    key: 2, // Availability Status Filter key
    type: 'multiNotEqual',
    field: 'ref_space_availability_status_desc',
    values: ['Deleted', 'Renewed', 'Sold', 'Withdrawn'],
    dataType: 'text',
  },
];
